module.exports = ".btn-default, .btn-default:focus {\n  border-color: #d9d9d9; }\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./node_modules/sass-loader/lib/loader.js??ref--8-3!./libs/chassis-core/src/style/chassis-core-vars.scss
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./node_modules/sass-loader/lib/loader.js??ref--8-3!./libs/chassis-core/src/style/chassis-core-vars.scss
// module chunks = styles